import { Component, Input, Output, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { TranslatePipe } from '@ngx-translate/core';

import { CounterService } from '../counter.service';
import { Counter } from '../counter.model';

import { Campaign } from '../../campaigns/campaign.model';

import { SharedDataService } from '../../shared/data.service';

declare var $: any;

@Component({
  selector: 'wm-counter-statistic',
  template: require('./counter-statistic.component.html'),
  providers: [TranslatePipe]
})
export class CounterStatisticComponent implements OnInit {
  counter_id: string;
  counter: Counter;
  campaign: Campaign;
  loading = true;

  public requests: Array<any>;

  constructor(
    private service: CounterService,
    private route: ActivatedRoute,
    private shared: SharedDataService,
    private translate: TranslatePipe
  ) {
    this.route.params.subscribe(params => {
      this.counter_id = params['id'];
    });
  }

  ngOnInit() {
    this.service.getCounter(this.counter_id).subscribe(result => {
      this.counter = result['counter'];
      this.loading = false;

      this.shared.awaitCampaign(result['counter']['campaign_id']).subscribe(campaign => {
        if (!!campaign) {
          this.campaign = campaign;
          this.getCounterStatistic();
        }
      });
    });
  }

  listCountUpdate(items_block) {
    let items = items_block['counters'];

    Object.keys(items).forEach(metric => {
      this.campaign.counters.forEach(function(item) {
        if (!!items[metric][item['id']]) {
          $(`#${item['id']} .counter-list__item__${metric}`).text(
            items[metric][item['id']]
          );
        } else {
          $(`#${item['id']} .counter-list__item__${metric}`).text(0);
        }
      });
    });
  }

  getCounterStatistic() {
    let total = {};

    if (!!this.counter['total']) {
      total[this.counter['id']] = this.counter['total'];
    }

    this.requests = [{
      ids: [this.counter['id']], metrics: ['views', 'sessions', 'users'],
      start_date: this.counter['created_at'], end_date: this.campaign['end_date'],
      total: total, statistic_type: 'counters'
    }];
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/counters/components/counter-statistic.component.ts